module.exports = __webpack_public_path__ + "img/jm.5e90dbbb.svg";